import React, { FC } from 'react';
import { useEditorContext } from '../../../../components/Editor/Context';
import cn from 'classnames';
import Delete from '../buttons/Delete';
import Settings from '../buttons/Settings/Settings';
import BlockBubbleMenu from '../../../../components/menus/BlockBubbleMenu';
import { DaDeviationThumbOptions } from '../../deviation-thumb';
import {
  getExtensionOptions,
  getNodeFromSelection,
} from '../../../../components/utils/tiptap';
import { isTouch } from '../../../../components/utils/browser';
import Convert from '../buttons/Convert';
import { EXTENSION_TYPE_NAME } from '../../constants';

export interface Props {
  scrollContainerRef?: React.RefObject<HTMLElement | null>;
}

const MenuButtons: FC<any> = ({ editor, forMobile = false }) => {
  const options: DaDeviationThumbOptions = getExtensionOptions(
    editor,
    EXTENSION_TYPE_NAME
  );
  return (
    <div
      className={cn(!forMobile && 'ds-surface-tertiary')}
      style={{ maxWidth: '100vw', display: 'flex', flexWrap: 'wrap' }}
    >
      {options.canConfigure && <Settings editor={editor} />}
      <Delete editor={editor} />
      <Convert editor={editor} />
    </div>
  );
};

const DaDeviationThumbBubbleMenu: FC<Props> = ({ scrollContainerRef }) => {
  const editor = useEditorContext();

  if (!editor) {
    return null;
  }

  if (!editor?.isEditable || isTouch()) {
    return null;
  }

  const nodes = getNodeFromSelection(editor);
  const open =
    editor.state.selection.empty === false &&
    nodes[1] &&
    nodes[1].type.name === EXTENSION_TYPE_NAME;

  const options: DaDeviationThumbOptions = getExtensionOptions(
    editor,
    EXTENSION_TYPE_NAME
  );
  let buttonCount = 3;
  if (!options.canConfigure) {
    buttonCount--;
  }

  return (
    <BlockBubbleMenu
      scrollContainerRef={scrollContainerRef}
      menuHeight={38}
      menuWidth={40 * buttonCount}
      editor={editor}
      open={open}
      childSelector="span > span"
    >
      <MenuButtons editor={editor} />
    </BlockBubbleMenu>
  );
};
DaDeviationThumbBubbleMenu.displayName = 'DaDeviationThumbBubbleMenu';

export default DaDeviationThumbBubbleMenu;
export { MenuButtons };
